import React from 'react';
import PropTypes from 'prop-types';

import Breeder from './components/Breeder';
import Age from './components/Age';
import Sire from './components/Sire';
import Dam from './components/Dam';
import Trainer from './components/Trainer';
import Owner from './components/Owner';
import DamSire from './components/DamSire';
import Standing from './components/Standing';
import SireComment from './components/SireComment';
import { isWeatherbysMobile } from '../../utils/horse';

function weatherbyDetails(props) {
    const compData = {
        ...props,
        isWeatherbysMobile: isWeatherbysMobile(props),
    };

    return (
        <div className="hp-details__data">
            <div className="hp-details__section">
                <span className="hp-details__label">Age</span>
                <div className="hp-details__detail-wrapper--weatherbys">
                    <Age key="Age" {...compData} />
                </div>
                <span className="hp-details__label">Sire</span>
                <div className="hp-details__detail-wrapper--weatherbys">
                    <Sire key="Sire" {...compData} />
                </div>
            </div>
            <div className="hp-details__section">
                <span className="hp-details__label">Dam</span>
                <div className="hp-details__detail-wrapper--weatherbys">
                    <Dam key="Dam" {...compData} />
                </div>
                <span className="hp-details__label">{'Dam\'s Sire'}</span>
                <div className="hp-details__detail-wrapper--weatherbys">
                    <DamSire key="DamSire" {...compData} />
                </div>
            </div>
            <div className="hp-details__section">
                <span className="hp-details__label">Sire Comment</span>
                <div className="hp-details__detail-wrapper--weatherbys-comment">
                    <SireComment key="SireComment" {...compData} />
                </div>
            </div>
            <div className="hp-details__section">
                <span className="hp-details__label">Breeder</span>
                <div className="hp-details__detail-wrapper--weatherbys">
                    <Breeder key="Breeder" {...compData} />
                </div>
                <span className="hp-details__label">Trainer</span>
                <div className="hp-details__detail-wrapper--weatherbys">
                    <Trainer key="Trainer" {...compData} hasPedigree />
                </div>
            </div>
            <div className="hp-details__section">
                <span className="hp-details__label">Racing Owner</span>
                <div className="hp-details__detail-wrapper--weatherbys">
                    <Owner key="Owner" {...compData} hasPedigree />
                </div>
            </div>
        </div>
    );
}

function weatherbyDetailsMobile(props) {
    const compData = {
        ...props,
        isWeatherbysMobile: isWeatherbysMobile(props),
    };

    return (
        <div className="hp-details__data">
            <div className="hp-details__section">
                <Age key="Age" {...compData} />
                <Sire key="Sire" {...compData} />
                <Dam key="Dam" {...compData} />
                <DamSire key="DamSire" {...compData} />
            </div>
            <div className="hp-details__section">
                <SireComment key="SireComment" {...compData} />
                <Breeder key="Breeder" {...compData} />
                <div className="hp-details__extraData">
                    <Trainer key="Trainer" {...compData} hasPedigree />
                    <Owner key="Owner" {...compData} hasPedigree />
                </div>
            </div>
        </div>
    );
}

function stallionDetails(props) {
    return (
        <div className="hp-details__data">
            <div className="hp-details__section">
                <Age key="Age" {...props} />
                <Sire key="Sire" {...props} />
                <Dam key="Dam" {...props} />
                <DamSire key="DamSire" {...props} />
                <Standing key="Standing" {...props} />
            </div>
            <div className="hp-details__section">
                <SireComment key="SireComment" {...props} />
                <Breeder key="Breeder" {...props} />
                <div className="hp-details__extraData">
                    <Trainer key="Trainer" {...props} hasPedigree />
                    <Owner key="Owner" {...props} hasPedigree />
                </div>
            </div>
        </div>
    );
}

const StallionDetails = (props) => {
    if (!props.weatherbysUid) {
        return stallionDetails(props);
    }

    const { isMobile } = props;

    if (!isMobile) {
        return weatherbyDetails(props);
    }

    return weatherbyDetailsMobile(props);
};

StallionDetails.propTypes = {
    isWeatherbysMobile: PropTypes.bool,
    weatherbysUid: PropTypes.string,
    isMobile: PropTypes.bool,
};

export default StallionDetails;



// WEBPACK FOOTER //
// ./src/js/horse/details/StallionDetails.jsx